<template>
  <div>
    <van-field
      v-model="obligee.qLRMC"
      v-validate="{required:true}"
      :data-vv-scope="dataVvScope"
      required
      data-vv-as="姓名"
      label="姓名"
      size="large"
      :readonly="!isEditable"
      label-width="90px"
    />
    <van-field
      v-model="obligee.zJLBNAME"
      v-validate="{required:true}"
      :data-vv-scope="dataVvScope"
      data-vv-as="证件类型"
      label="证件类型"
      size="large"
      placeholder="选择证件类型"
      required
      :readonly="!isEditable"
      clickable
      label-width="90px"
      @click="handleCertificateStatusClick"
    />
    <van-popup v-model="showCertificateStatusPicker" position="bottom" :readonly="!isEditable">
      <van-picker
        :columns="certificateStatus"
        show-toolbar
        :default-index="certificateStatusPickerDefaultIndex"
        @confirm="handleCertificateStatusPickerConfirm"
        @cancel="showCertificateStatusPicker = false"
      />
    </van-popup>
    <van-field
      v-model="obligee.zJHM"
      v-validate="{required:true}"
      :data-vv-scope="dataVvScope"
      required
      label="身份证号"
      size="large"
      :readonly="!isEditable"
      label-width="90px"
    />
    <van-field
      v-model="obligee.dH"
      v-validate="{required:true}"
      :data-vv-scope="dataVvScope"
      required
      label="手机号码"
      size="large"
      label-width="90px"
    />
  </div>
</template>

<script>
import { CertificateStatus } from '@/utils/enums'

export default {
  components: {},
  props: {
    obligee: {
      type: Object,
      default: () => {
        return {
          qLRMC: '', // 权利人名称
          zJLB: '', // 证件类别
          zJLBNAME: '', // 证件类别名称
          zJHM: '', // 证件号码
          dH: '' // 电话
        }
      }
    },
    dataVvScope: {
      type: String,
      default: null
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      certificateStatusPickerDefaultIndex: 0,
      showCertificateStatusPicker: false
    }
  },
  computed: {
    certificateStatus() {
      let certificateStatusItems = []
      if (this.obligee.qLRLX === '1') {
        certificateStatusItems = CertificateStatus.getItems().filter(c => {
          return c.value < 6 || c.value === 99
        })
      } else if (this.obligee.qLRLX === '2') {
        certificateStatusItems = CertificateStatus.getItems().filter(c => {
          return c.value > 5
        })
      } else {
        certificateStatusItems = CertificateStatus.getItems()
      }

      return certificateStatusItems
    },
    validationErrors() {
      return this.$validator.errors
    }
  },
  watch: {
    validationErrors: {
      handler(newValue, oldValue) {
        // ErrorBag.any()获取的是当前域是否存在验证错误
        this.$emit('validate', !newValue.any())
      },
      deep: true
    }
  },
  mounted() {
    // 验证表单
    // this.$validator.validateAll()
    this.$validator.validateAll(this.dataVvScope)
    // 处理默认选中
    this.handeleCertificateStatusPickerDefautSelected()
  },
  methods: {
    handleCertificateStatusClick() {
      if (this.isEditable) {
        this.showCertificateStatusPicker = true
      }
    },
    handleCertificateStatusPickerConfirm(certificateStatus) {
      this.obligee.zJLB = certificateStatus.value
      this.obligee.zJLBNAME = certificateStatus.text
      this.showCertificateStatusPicker = false
    },
    // 处理默认选中
    handeleCertificateStatusPickerDefautSelected() {
      if (this.certificateStatus.map(c => c.value).indexOf(this.obligee.zJLB) !== -1) {
        this.certificateStatusPickerDefaultIndex = this.certificateStatus.findIndex(c => c.value === this.obligee.zJLB)
        // .map(c => c.value)
        // .indexOf(this.obligee.zJLB)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
